export const environment = {
  production: true,
  baseUrl: 'https://mqtt.cloud4link.com/api',
  baseSignalRUrl: 'https://mqtt.cloud4link.com',
  logo: 'logo-no-background.svg',
  login: true,
  configurations: [
    {
      label: "Manage Group",
      url: "groups",
      icon: "fa-layer-group",
    },
    {
      label: "Manage Devices",
      url: "devices",
      icon: "fa-microchip",
    },
    {
      label: "Manage Plan",
      url: "rules",
      icon: "fa-file",
    },
    {
      label: "Manage Sensor Automation",
      url: "sensor-automation",
      icon: "fa-thermometer-half",
    },
    {
      label: "Manage Scenario",
      url: 'commands',
      icon: 'fa-code'
    },
    {
      label: "Configuration",
      url: 'config',
      icon: 'fa-cog'
    },
    {
      label: "Access Devices",
      url: 'accessdevice',
      icon: 'fa-cog'
    },
    {
      label: "See Pairs",
      url: "pairs",
      icon: "fa-code-branch",
    },
    {
      label: "Logs",
      url: "logs",
      icon: "fa-book",
    },
      {
      label: "Manage Blinders",
      url: 'blinders',
      icon: 'fa-barcode',
      class: 'fa-rotate-90'
    },
    {
      label: "Manage Holidays",
      url: 'holiday',
      icon: 'fa-glass-cheers'
    }
  ]
};
